/* unplugin-vue-components disabled */import { render } from "./save-doc.vue?vue&type=template&id=07337624&scoped=true"
import script from "./save-doc.vue?vue&type=script&lang=js"
export * from "./save-doc.vue?vue&type=script&lang=js"

import "./save-doc.vue?vue&type=style&index=0&id=07337624&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07337624"],['__file',"src/components/cards/save-doc.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "07337624"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('07337624', __exports__)) {
    api.reload('07337624', __exports__)
  }
  
  module.hot.accept("./save-doc.vue?vue&type=template&id=07337624&scoped=true", () => {
    api.rerender('07337624', render)
  })

}


export default __exports__